// src/components/FeatureSlider/FeaturesSection.jsx
import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './FeaturesSection.css';

// 5つの魅力データ（ここに統合しました）
const featuresData = [
  {
    enTitle: '150-Year Machiya',
    jpTitle: '歴史ある町家で過ごす',
    description: '150年以上の歴史を誇る金澤町家「あけぼの」。書院造りの様式美や伝統的な建築の工夫が随所に残る空間で、歴史が息づく特別な滞在をご体感ください。',
    image: '/images/feature-machiya.png',
    link: '/features/machiya'
  },
  {
    enTitle: 'A Garden Retreat of Silence',
    jpTitle: '季節の庭園に包まれて',
    description: '約100坪の敷地に広がる静寂の庭園。お部屋や浴室から四季折々の美しさを眺め、金沢の豊かな庭園文化と心澄み渡る時間をお楽しみいただけます。',
    image: '/images/feature-garden.jpg',
    link: '/features/garden'
  },
  {
    enTitle: 'Prime Location',
    jpTitle: '金沢観光の拠点に最適な立地',
    description: '兼六園や金沢21世紀美術館へ徒歩8分。にし茶屋街や金沢城公園、香林坊にもアクセス抜群な、金沢観光の拠点として最適なロケーションです。',
    image: '/images/access1.jpg',
    link: '/features/primelocation'
  },
  {
    enTitle: 'Living with Traditional Crafts',
    jpTitle: '伝統工芸が佇む空間',
    description: '輪島塗や九谷焼、珠洲焼など石川・能登の伝統工芸品を館内に展示。美術館のように美しい工芸品に囲まれた、上質なご滞在をお楽しみください。',
    image: '/images/machiya2.jpg',
    link: '/features/craft'
  },
  {
    enTitle: 'Comfort & History',
    jpTitle: '快適性と歴史の風情',
    description: '伝統ある町家をフルリノベーション。趣ある梁や壁はそのままに、最新のキッチンや浴室、快適な空調を完備し、上質な心地よさを提供します。',
    image: '/images/feature-renovation.jpg',
    link: '/features/renovation'
  }
];

const ScrollFeatureItem = ({ feature, isLeft, isEnglish }) => {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 90%', 'end 10%']
  });

  const yPos = useTransform(scrollYProgress, [0, 1], [30, -30]);

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  // 英語ページの場合は /en/ をリンク先頭に付与
  const targetLink = isEnglish ? `/en${feature.link}` : feature.link;

  return (
    <div className={`feature-block ${isLeft ? 'left' : 'right'}`} ref={ref}>
      {/* 画像リンク */}
      <motion.a
        href={targetLink}
        className="feature-image-wrapper"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={fadeUp}
        style={{ display: 'block', textDecoration: 'none' }}
      >
        <motion.img
          src={feature.image}
          alt={feature.enTitle}
          className="feature-image"
          whileInView={{ scale: 1.05 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          viewport={{ once: true }}
        />
      </motion.a>

      {/* テキストボックス */}
      <motion.div
        className="feature-text-box"
        style={{ y: yPos }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        variants={fadeUp}
      >
        <h3 className="feature-title-en">{feature.enTitle}</h3>
        <p className="feature-title-jp">{feature.jpTitle}</p>
        <p className="feature-desc">
          {feature.description}
        </p>

        {/* 詳細ページへのボタン */}
        <a href={targetLink} className="feature-link-btn">
          {isEnglish ? 'Discover More ↗' : '詳細を見る ↗'}
        </a>
      </motion.div>
    </div>
  );
};

function FeaturesSection({ isEnglish }) {
  return (
    <section className="features-luxury-section">
      <h2 className="section-title">
        {isEnglish ? 'The Akebono Experience' : 'あけぼの 5つの魅力'}
      </h2>
      <div className="features-container">
        {featuresData.map((feature, index) => (
          <ScrollFeatureItem
            key={index}
            feature={feature}
            isLeft={index % 2 === 0}
            isEnglish={isEnglish}
          />
        ))}
      </div>
    </section>
  );
}

export default FeaturesSection;